import ColorSelector from "./component-library7.mjs";
import "./component-library219.mjs";
import normalizeComponent from "./component-library81.mjs";
const _sfc_main = {
  name: "OfferTileColors",
  components: { ColorSelector },
  props: {
    variants: {
      type: Array,
      required: true
    }
  },
  computed: {
    activeIndex() {
      return Math.max(
        0,
        this.variants.findIndex((variant) => !!variant.active)
      );
    }
  },
  methods: {
    clickedItem({ variant }) {
      if (this.$router) {
        this.$router.push(variant.path);
        return;
      }
      window.open(variant.path, "_self");
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("ColorSelector", { staticClass: "offer-tile-color-display", attrs: { "circle": "", "vertical-left": "", "variants": _vm.variants.slice(0, 4), "value": _vm.activeIndex }, on: { "select-variant": _vm.clickedItem } });
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "9fc49a08",
  null,
  null
);
const OfferTileColors = __component__.exports;
export {
  OfferTileColors as default
};
